import repository from '@/utils/repository';

const resource = '/move/MNG_DmTop';

export default {
    listDM: (data) => {
        return repository.post(`${resource}/listDM`, {
            ...data
        });
    },
    getGroup: (data) => {
        return repository.post(`${resource}/getGroup`, {
            ...data
        });
    },
    getFolder: (data) => {
        return repository.post(`${resource}/getFolder`, {
            ...data
        });
    },
    getFolderCount: (data) => {
        return repository.post(`${resource}/getFolderCount`, {
            ...data
        });
    },
    getFolderMessage: (data) => {
        return repository.post(`${resource}/getFolderMessage`, {
            ...data
        });
    },
    storeMessage: (data) => {
        return repository.post(`${resource}/storeMessage`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    storeGroup: (data) => {
        return repository.post(`${resource}/storeGroup`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    storeFolder: (data) => {
        return repository.post(`${resource}/storeFolder`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    readMessage: (data) => {
        return repository.post(`${resource}/readMessage`, {
            ...data
        });
    },
    undoSendMessage: (data) => {
        return repository.post(`${resource}/undoSendMessage`, {
            ...data
        });
    },
    deleteGroup: (data) => {
        return repository.post(`${resource}/deleteGroup`, {
            ...data
        });
    },
    deleteFolder: (data) => {
        return repository.post(`${resource}/deleteFolder`, {
            ...data
        });
    },
    syncFolderMessage: (data) => {
        return repository.post(`${resource}/syncFolderMessage`, {
            ...data
        });
    }
};
